import { get, post } from '@/plugins/axios'
import axios from 'axios'
import store from '@/store'
/**
* 查询平台订单详情列表
* @param {Object} params
*/
export const getSign = () => {
  return post('/customer/oss/sign?path=client/')
}

/**
 * 获取client_id
 *
 * @param {*} params
 */
export const getClientIdApi = () => {
  return get('/crm/paypal/client/id')
}

// 上传文件
export const uploadFileApi = (data: any) => {
  // console.log(data)
  // const formData:any = new FormData()
  // formData.append('file', data.file)
  // formData.append('path', data.path)
  // return post('/customer/oss/putOSS', {data:formData}, {
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   }
  // })

  const token = store.getters.token
  return axios({
    url: process.env.VUE_APP_URL + '/customer/oss/putOSS',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-AuthToken': token
    }
  })
}
